import { RequestHelpExperience } from 'generated/user-backend';

const REQUEST_HELP_EXPERIENCE_KEY = 'apollo.requestHelpExperience';
const REQUEST_HELP_SWITCH_TO_NEW_NOTICE_KEY = 'apollo.requestHelpSwitchedToNew';

export const getRequestHelpExperience = (): RequestHelpExperience => {
    try {
        const storedExperience = window.localStorage.getItem(REQUEST_HELP_EXPERIENCE_KEY);
        return storedExperience === String(RequestHelpExperience.Legacy)
            || storedExperience?.toLowerCase() === 'legacy'
            ? RequestHelpExperience.Legacy
            : RequestHelpExperience.New;
    } catch {
        return RequestHelpExperience.New;
    }
};

export const setRequestHelpExperience = (experience: RequestHelpExperience): void => {
    try {
        window.localStorage.setItem(REQUEST_HELP_EXPERIENCE_KEY, String(experience));
    } catch {
        // Navigation still works when storage is unavailable; only the preference is not retained.
    }
};

export const isLegacyRequestHelpPreferred = (): boolean =>
    getRequestHelpExperience() === RequestHelpExperience.Legacy;

export const persistExperienceWithRollback = async (
    currentExperience: RequestHelpExperience,
    nextExperience: RequestHelpExperience,
    persistExperience: (experience: RequestHelpExperience) => Promise<unknown>,
    completeTransition: () => Promise<unknown>,
): Promise<void> => {
    await persistExperience(nextExperience);
    try {
        await completeTransition();
    } catch (error) {
        await persistExperience(currentExperience);
        throw error;
    }
};

export const markSwitchedToNewExperience = (): void => {
    try {
        window.sessionStorage.setItem(REQUEST_HELP_SWITCH_TO_NEW_NOTICE_KEY, 'true');
    } catch {
        // The experience preference still changes when session storage is unavailable.
    }
};

export const consumeSwitchedToNewExperienceNotice = (): boolean => {
    try {
        const shouldShow = window.sessionStorage.getItem(REQUEST_HELP_SWITCH_TO_NEW_NOTICE_KEY) === 'true';
        window.sessionStorage.removeItem(REQUEST_HELP_SWITCH_TO_NEW_NOTICE_KEY);
        return shouldShow;
    } catch {
        return false;
    }
};
